import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {PorQue} from '@/components/ui/por-que'

/** Solo cuando el capítulo no cambiaría; si cambia habla `RegimeDriftBanner`, nunca los dos. */
export function RosterDriftNotice({
  businessId,
  declared,
  active,
}: {
  businessId: string
  declared: number
  active: number
}) {
  const {t} = useTranslation()
  return (
    <div className="notice-amber rounded-lg px-4 py-3.5" data-testid="roster-drift-notice">
      <p className="text-sm">{t('dashboard.rosterDrift.body', {declared, active})}</p>
      <div className="mt-1.5">
        <PorQue
          label={t('dashboard.rosterDrift.porque')}
          testId="roster-drift-porque"
          contenidoTestId="roster-drift-porque-detalle">
          {t('dashboard.rosterDrift.porqueBody')}
        </PorQue>
      </div>
      <div className="mt-3 flex flex-col items-start gap-2">
        <Button asChild size="sm">
          <Link to={`/businesses/${businessId}/employees`}>{t('dashboard.rosterDrift.registerPeople')}</Link>
        </Button>
        <Button asChild size="sm" variant="outline">
          <Link to={`/businesses/${businessId}/sgsst`}>{t('dashboard.rosterDrift.updateCount')}</Link>
        </Button>
      </div>
    </div>
  )
}
